import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { useAccount, useConnect, useDisconnect, WagmiProvider } from "wagmi";
import wagmiConfig from "../common/wagmi-config";
import WalletConnector from "../components/WalletConnector/WalletConnector";
import { useMainLayoutHeaderSlot } from "../layouts/MainLayout/providers/MainLayoutHeaderSlotProvider";
import { useDebounce } from "usehooks-ts";

const queryClient = new QueryClient();

function WalletConnectorProvider({ children }) {
  const {
    isConnected,
    isConnecting,
    isReconnecting,
    address,
    connector,
    chain,
  } = useAccount();
  const { connectors } = useConnect();
  const { disconnect } = useDisconnect();
  const { setToolbarSlot } = useMainLayoutHeaderSlot();
  const isConnectingDebounced = useDebounce(isConnecting, 200);
  const isReconnectingDebounced = useDebounce(isReconnecting, 200);

  useEffect(() => {
    setToolbarSlot(
      <WalletConnector
        isConnected={isConnected}
        isConnecting={isConnectingDebounced}
        isReconnecting={isReconnectingDebounced}
        address={address}
        connectors={connectors}
        connector={connector}
        disconnect={disconnect}
        chain={chain}
      />
    );

    return () => {
      setToolbarSlot(null);
    };
  }, [isConnected, isConnectingDebounced, address, isReconnectingDebounced]);

  return <>{children}</>;
}

export default ({ children }) => (
  <WagmiProvider config={wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <WalletConnectorProvider>{children}</WalletConnectorProvider>
    </QueryClientProvider>
  </WagmiProvider>
);
